module.exports = __webpack_public_path__ + "static/media/swf.cab6a2e6.png";